import { render } from "./ModuleCard.vue?vue&type=template&id=7be245d9&scoped=true"
import script from "./ModuleCard.vue?vue&type=script&lang=js"
export * from "./ModuleCard.vue?vue&type=script&lang=js"

import "./ModuleCard.vue?vue&type=style&index=0&id=7be245d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be245d9"]])

export default __exports__